<template>
    <div class="row py-md-4">
        <div class="col-12">
            <h1 class="card-title h5">{{ $t('cancellation_optin.title') }}</h1>
            <p class="card-text">
                {{ $t('cancellation_optin.text') }}
            </p>
            <p class="card-text">
                {{ $t('cancellation_optin.text2') }}
            </p>
            <div class="form-row">
                <div class="form-group form-check">
                    <input type="checkbox" class="form-check-input" v-model="acceptCancellationTerms" id="acceptCancellationTerms" />
                    <i18n path="cancellation_optin.checkbox.label" class="form-check-label" tag="label" for="acceptCancellationTerms"/>
                </div>
            </div>
        </div>
        <div class="col-12 text-center pt-4">
            <button class="btn btn-primary" @click="sendCancellationOptin" v-if="acceptCancellationTerms">
                {{ $t('cancellation_optin.accept') }}
            </button>
            <button class="btn btn-primary disabled" v-else>
                {{ $t('cancellation_optin.accept') }}
            </button>
        </div>
        <div class="col-12 text-center pt-3 mt-3">
            <button class="btn btn-secondary btn-sm text-nowrap" @click="$store.dispatch('reset')">
                {{ $t('cancellation_optin.decline') }}
            </button>
        </div>
        <div class="col-12 text-center pt-3 mt-3">
            <i18n path="bookingServiceSuccess.supporting_text.common.customer_support.text" tag="p"
                  class="card-text text-secondary">
                <CustomerServiceEmail/>
                <CustomerServicePhone/>
            </i18n>
        </div>
    </div>
</template>

<script>
import InfoIcon from "../../../animod-shop-ssr/src/assets/icons/info.svg";
import ContactForm from '@/components/ContactForm'
import CustomerServiceEmail from '../components/CustomerServiceEmail'
import CustomerServicePhone from '../components/CustomerServicePhone'
import ExternalIncentiveBlock from '../components/ExternalIncentiveBlock'
import FinishOrderForm from "@/components/FinishOrderForm.vue";
import OrderDetails from "@/components/OrderDetails.vue";
import CustomerServiceBlock from "./CustomerServiceBlock.vue";
import {mapGetters, mapState} from "vuex";

export default {
    name: 'CancellationOptin',
    components: {
        CustomerServiceBlock,
        FinishOrderForm, ContactForm, CustomerServiceEmail, CustomerServicePhone, ExternalIncentiveBlock, OrderDetails, InfoIcon },
    data () {
        return {
            isSendingData: false,
            dataIsSent: false,
            acceptCancellationTerms: false
        }
    },
    props: {},
    computed: {
        ...mapState(['voucher']),
        ...mapGetters(['voucherCode']),
        hasBonus() {
            return this.$store.state.voucher.eligibleForExternalIncentive;
        },
    },
    methods: {
        async sendCancellationOptin() {
            console.log("sendCancellationOptin");
            try {
                this.isSendingData = true
                this.$store.dispatch('sendCancellationOptin', this.voucherCode);
                this.isVoucherInfoFormSubmitted = true
            } finally {
                this.isSendingData = false
            }
        },
    }
}
</script>

<style scoped lang="scss">
h4 {
    color: #525252;
    display: block;
    font-size: 1.5rem;
    margin: 0.625rem auto;
    text-align: center;
}
.tooltip-container {
    display:inline-block;
    width:20px;
    height:20px;
}
.info-icon {
    display:inline-block;
    width:20px;
    height:20px;
    color:#525252;
    fill:#525252;
}
.tooltip {
    color: #000;
    background-color: #fff;
    will-change: transform;
    top: -60px;
    left: 240px;
    position: absolute;
    border-radius: 2px;
    padding: 6px 10px;
    box-shadow: 0px 0px 3px rgba(#666, 0.8);
    max-width: 320px;
    z-index: 100;
    display:block;
    opacity: 1;
}
</style>
